import React from 'react';
import CommandHeader from "../components/CommandHeader";
import { classList } from "../helpers/ClassList";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../components/ui/accordion";

function EducationPage() {
    // Sort by year, then semester (Fall after Spring), most recent first
    const semesterRank = { Spring: 0, Summer: 1, Fall: 2 };
    const sortedClasses = [...classList].sort((a, b) => {
        const [aTerm, aYear] = a.semester.split(" ");
        const [bTerm, bYear] = b.semester.split(" ");

        if (Number(aYear) !== Number(bYear)) {
            return Number(bYear) - Number(aYear);
        }
        return (semesterRank[bTerm] ?? 0) - (semesterRank[aTerm] ?? 0);
    });

    return (
        <div className="mx-auto max-w-3xl px-6 py-12">
            <CommandHeader command="cat ~/csu/coursework.txt" />
            <h1 className="mt-2 text-3xl font-bold tracking-tight sm:text-4xl">Coursework at CSU</h1>
            <p className="mt-3 text-muted-foreground">
                The courses that shaped how I build systems: distributed computing, networks,
                security, and the fundamentals under them. Most recent first.
            </p>

            <Accordion type="single" collapsible className="mt-8">
                {sortedClasses.map((classItem) => (
                    <AccordionItem value={classItem.courseCode} key={classItem.courseCode}>
                        <AccordionTrigger className="text-left">
                            <span>
                                {classItem.courseName}
                                <span className="ml-2 font-mono text-xs text-muted-foreground">
                                    {classItem.courseCode}
                                </span>
                            </span>
                        </AccordionTrigger>
                        <AccordionContent>
                            <div className="space-y-2 text-sm text-muted-foreground">
                                <p><span className="font-medium text-foreground">Semester:</span> {classItem.semester}</p>
                                <p><span className="font-medium text-foreground">Skills:</span> {classItem.technologiesLearned}</p>
                                <p>{classItem.description}</p>
                            </div>
                        </AccordionContent>
                    </AccordionItem>
                ))}
            </Accordion>
        </div>
    );
}

export default EducationPage;
